import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import {
  AssignRole,
  GetManegment,
  GetRoute,
  RoleUpdate,
  RoleView,
} from "../../../api/UserRoleServices";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import { ToastMain ,SweetAlertShow} from "../../master/Master";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserHeader from "./UserHeader";

const UpdateUserRole = () => {
  const hasAccess = usePrivateLink();
  const location = useLocation();
  const [entities, setEntities] = useState([]);
  const [id, setId] = useState(null);
  const [entityFields, setEntityFields] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const idFromQuery = queryParams.get("id");
    if (idFromQuery) {
      setId(idFromQuery);
    }
  }, [location]);

  useEffect(() => {
    if (id) {
      getUserRoles();
    }
  }, [id]);

  useEffect(() => {
    fetchEntities();
    fetchEntityFields();
  }, []);

  useEffect(() => {
    if (id) {
      getUserRoles();
    }
  }, []);

  const getUserRoles = async () => {
    setLoading(true); // 🌀 Show loading spinner
    let addURl = `&id=${id}`;
    try {
      const response = await RoleView(addURl);
      if (response?.data.status) {
        // console.log('id pass ho gai', response.data)
        setData(response?.data?.data[0]);
      } else {
        ToastMain.fire({
          icon: "info",
          title: response?.data?.message || "something went wrong",
        });
      }
    } catch (error) {
      ToastMain.fire({
        icon: "error",
        title: error?.response?.data?.message || "something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  const roleAssign = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const name = formData.get("name");
    const id = formData.get("id");

    const permissions = Object.entries(selectedPermissions).map(
      ([management_id, routes]) => ({
        management_id: Number(management_id),
        route_ids: routes.map((r) => r.id),
      })
    );
    try {
      const response = await RoleUpdate({
        name: name,
        permissions: permissions,
        id: id,
      });
      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Permissions saved successfully!",
        });
        navigate("/role");
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong",
        // });

        SweetAlertShow('info','Warning', response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    }
  };

  const fetchEntities = async () => {
    try {
      const res = await GetManegment();
      if (res.data.status) {
        setEntities(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching entities", error);
    }
  };

  const fetchEntityFields = async () => {
    try {
      const res = await GetRoute();
      if (res?.data?.data) {
        const grouped = groupFieldsByEntity(res.data.data);
        setEntityFields(grouped);
      }
    } catch (error) {
      console.error("Error fetching entity fields", error);
    }
  };

  const groupFieldsByEntity = (fields) => {
    const grouped = {};
    fields.forEach((field) => {
      const key = field.managment_id;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push({ id: field.id, name: field.name }); // ✅ Object भेजो
    });
    return grouped;
  };

  const handleCheckboxChange = (entityId, fieldObj) => {
    setSelectedPermissions((prev) => {
      const current = prev[entityId] || [];
      const alreadySelected = current.find((f) => f.id === fieldObj.id);

      const updated = alreadySelected
        ? current.filter((f) => f.id !== fieldObj.id)
        : [...current, fieldObj];

      return { ...prev, [entityId]: updated };
    });
  };

  const handleSelectAll = (entityId) => {
    const allFields = entityFields[entityId] || [];
    const allSelected =
      selectedPermissions[entityId]?.length === allFields.length;
    setSelectedPermissions((prev) => ({
      ...prev,
      [entityId]: allSelected ? [] : [...allFields],
    }));
  };

  useEffect(() => {
    if (data) {
      const extractedRoutes = data?.permissions
        ?.map((permission) => ({
          id: permission?.route?.id,
          name: permission?.route?.name,
        }))
        .filter((route) => route.id && route.name);
      console.log("extractedRoutes", extractedRoutes);
      //   setSelectedPermissions(extractedRoutes);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      const grouped = data?.permissions
        ?.map((permission) => ({
          id: permission?.route?.id,
          name: permission?.route?.name,
          management_id: permission?.management?.id,
        }))
        .filter((route) => route.id && route.name)
        .reduce((acc, route) => {
          const key = route.management_id;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push({ id: route.id, name: route.name });
          return acc;
        }, {});

      setSelectedPermissions(grouped);
    }
  }, [data]);

  useEffect(() => {
    console.log(selectedPermissions);
  }, [selectedPermissions]);

  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const userPermissions = localStorage.getItem("user_permissions");
    const parsedPermissions = userPermissions
      ? JSON.parse(userPermissions)
      : [];

    setPermissions(JSON.parse(userPermissions)?.permissions);
  }, []);
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <div className="d-flex gap-2">
                    <div className="col-md-3">
                      <UserHeader data={"User Portal"} />
                    </div>
                    <div className="col-md-9">
                      <div className="card">
                        <div className="card-body">
                          <form onSubmit={roleAssign}>
                            <div className="container py-5">
                              <h2
                                className="text-center fw-bold fs-2 mb-5"
                                style={{ color: "#7b2cbf" }}
                              >
                                🛡️ Update / View Role Permission Settings
                              </h2>

                              <input type="hidden" name="id" value={id} />
                              <div className="d-flex justify-content-between">
                                <div className="col-md-6 form-floating form-floating-outline mb-5">
                                  <input
                                    type="text"
                                    className="form-control input-lowercase"
                                    name="name"
                                    placeholder="Username"
                                    defaultValue={data?.name}
                                  />
                                  <label>Username</label>
                                </div>{" "}
                                <Link
                                  to={"/role"}
                                  className="btn btn-sm btn-outline-primary mt-5 mb-5"
                                >
                                  <i className="bi bi-arrow-left-circle me-1"></i>{" "}
                                  Back
                                </Link>
                              </div>

                              {entities.map((entity) => {
                                const allFields = entityFields[entity.id] || [];
                                const selectedFields =
                                  selectedPermissions[entity.id] || [];
                                const allSelected =
                                  selectedFields.length == allFields.length &&
                                  allFields.length > 0;

                                return (
                                  <div
                                    key={entity.id}
                                    className="card mb-4 border-0 shadow rounded-4"
                                    style={{
                                      background: "rgba(255, 255, 255, 0.75)",
                                      backdropFilter: "blur(10px)",
                                    }}
                                  >
                                    <div className="card-header  d-flex justify-content-between align-items-center rounded-top-4 py-3 px-4 border-bottom">
                                      <h5 className="mb-0 text-capitalize fw-semibold text-primary">
                                        {entity.name} (ID: {entity.id})
                                      </h5>
                                      {allFields.length > 0 && (
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input text-primary"
                                            type="checkbox"
                                            id={`selectAll-${entity.id}`}
                                            checked={allSelected}
                                            onChange={() =>
                                              handleSelectAll(entity.id)
                                            }
                                          />
                                          <label
                                            className="form-check-label text-primary"
                                            htmlFor={`selectAll-${entity.id}`}
                                          >
                                            Select All
                                          </label>
                                        </div>
                                      )}
                                    </div>

                                    <div className="card-body px-9 pt-3 pb-4">
                                      <div className="row g-3">
                                        {allFields.map((field, index) => (
                                          <div
                                            className="col-md-3"
                                            key={field + index}
                                          >
                                            <div className="form-check p-2 rounded-3  d-flex align-items-center">
                                              <input
                                                className="form-check-input me-2"
                                                type="checkbox"
                                                id={`${entity.id}-${field.id}`}
                                                checked={
                                                  selectedPermissions[
                                                    entity.id
                                                  ]?.some(
                                                    (f) => f.id == field.id
                                                  ) || false
                                                }
                                                onChange={() =>
                                                  handleCheckboxChange(
                                                    entity.id,
                                                    field
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2 text-capitalize fw-normal"
                                                htmlFor={`${entity.id}-${field.id}`}
                                              >
                                                {field.name}
                                              </label>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}

                              <div className="text-center mt-4">
                                {hasAccess('/settings/user_role/update') && (
                                  <>
                                    {!(data?.id >= 1 && data?.id <= 14) && (
                                      <>
                                        <button
                                          className="btn btn-lg btn-primary px-5 rounded-pill shadow"
                                          type="submit"
                                        >
                                          💾 Update Permissions
                                        </button>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateUserRole;
